import React from "react";
import { Card, CardContent, CardHeader, Icon } from "semantic-ui-react";
import "./styles.scss";
import { AssetPreview, AssetPreviewCard } from "./components/AssetPreviewCard";
import { Category } from "../../interfaces";

interface OwnProps {
  assetList: AssetPreview[];
  assetType: "Prompt" | "Campaign";
  category: Category;
  selectCategory: (category: Category) => void;
  selectAsset?: (asset: AssetPreview) => void;
}

type Props = OwnProps;

export const CategoryCard: React.FC<Props> = ({ assetList, assetType, category, selectCategory, selectAsset }) => {
  const selectCard = () => {
    if (assetList.length == 1) selectAsset && selectAsset(assetList[0]!);
    else selectCategory(category);
  };

  return assetList.length ? (
    <Card className={`categoryCard`} onClick={selectCard}>
      <CardContent>
        <CardHeader className={"clickableHeader"}>{category.name}</CardHeader>
        <div className="previewGrid">
          {assetList.slice(0, 9).map(asset => {
            return (
              <AssetPreviewCard
                asset={asset}
                onClick={(a, e) => {
                  selectAsset && selectAsset(a);
                  e.stopPropagation();
                }}
              />
            );
          })}
        </div>
      </CardContent>
      <CardContent className={"clickableHeader"} extra>
        <a className={"viewAllLink"}>
          <Icon name="file" />
          {assetList.length} {assetType}
          {assetList.length > 1 ? "s - Click here to view all" : ""}
        </a>
      </CardContent>
    </Card>
  ) : undefined;
};
